module.exports = __webpack_public_path__ + "img/certified.0741b36e.svg";